<!--
  Layout for the logged-in guest area (/guest and subpages).
  Structure + scroll behavior like on a product page (e.g. bomplitz-w84.php):
  - On top the classic LayoutHeader (Travanto logo). It is NOT sticky and
    scrolls away when scrolling down (LayoutHeader = "z-50 relative").
  - Below it the "back" bar (GuestReturnHeader) - analogous to the product
    page's "images/overview" bar: it is "sticky top-0" and stays pinned at the
    top once the large header has scrolled out of view.
  Newsletter and footer are shown on every page of this area, like in the rest
  of the portal.
-->
<template>
  <div class="min-h-screen text-left flex flex-col overflow-x-clip">
    <LayoutHeader />
    <GuestReturnHeader :to="backTo" />
    <div class="flex-1">
      <!-- Logged out on /guest*: login prompt instead of the page content (no
           404). After a successful login in the modal isLoggedIn reactively
           becomes true and the page content appears without navigation. -->
      <GuestLoginPrompt v-if="!isLoggedIn" />
      <slot v-else />
    </div>
    <LayoutNewsletter />
    <LayoutFooter />
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const backTo = computed(() => (route.meta.backTo as string) ?? '/')

// The session is already loaded at this point (the guest-only middleware
// awaits getSession before rendering).
const { isLoggedIn } = useGuest()
</script>
